module.exports = __webpack_public_path__ + "img/redChrysanthemum.61ead919.jpg";